
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import iconlike from "@/assets/img/icon-like.png";
import iconnolike from "@/assets/img/icon-nolike.png";
import t from "@common/src/i18n/t";
const study = namespace("study");
@Component({})
export default class News extends Vue {
  @study.Action queryContentClassPage;
  @study.Action queryContentPage;
  @study.Action queryContentDetail;
  @study.Action likeContent;
  dayjs = dayjs;
  iconlike = iconlike;
  iconnolike = iconnolike;
  @Watch("searchText")
  searchTextWatch() {
    if (this.searchText === "") {
      this.searchFlag = false;
    }
  }
  filterKeyLight(text) {
    if (!this.searchText) return text;
    const result = text.replace(
      new RegExp(this.searchText, "g"),
      `<span style="color:#FE9500;">${this.searchText}</span>`
    );
    return result;
  }
  searchText = "";
  active = "0";
  page = {
    pageNum: 1,
    pageSize: 10
  };
  handleSizeChange(val) {
    this.page.pageSize = val;
    this.getQueryContentPage();
  }
  handleCurrentChange(val) {
    this.page.pageNum = val;
    this.getQueryContentPage();
  }
  newsClass = [
    {
      className: t("base.all"),
      classCode: "0",
      contentSum: "",
      createTime: ""
    }
  ];
  queryList = [];
  contentDetail: any = {};
  resList = {};
  classCode = "0";
  className = t("base.all");
  item: any = {};
  newsFlag = true;
  hoverActive = "";
  contentCode = undefined;
  get searchTextResult() {
    return this.$route.query.search;
  }
  created() {
    let query = this.$route.query as any;
    this.init();
    if (query.search) {
      this.searchText = query.search;
    }
    if (this.$route.query.class) {
      this.classCode = query.class;
      this.active = query.class;
      if (query.content) {
        this.classCode = query.class;
        this.contentCode = query.content;
        // this.handelGetHtml()
        this.newsFlag = false;
        this.getDetail();
      }
    } else {
      this.classCode = "0";
      this.active = "0";
    }
  }

  async init() {
    const res = await this.queryContentClassPage({ pageNum: 1, pageSize: 999 });
    this.newsClass = [
      {
        className: t("base.all"),
        classCode: "0",
        contentSum: "",
        createTime: ""
      },
      ...res.data.list
    ];
    const filterClass = this.newsClass.filter(item => {
      return item.classCode === this.classCode;
    });
    this.className = filterClass.length > 0 ? filterClass[0].className : this.newsClass[0].className;
    if (!this.$route.query.contentCode) {
      this.getQueryContentPage();
    }
  }
  hoverMouse(index) {
    this.hoverActive = index;
  }
  async getQueryContentPage() {
    let param = {
      searchKey: this.searchText,
      ...this.page,
      classCode: this.classCode === "0" ? "" : this.classCode
    };
    const res = await this.queryContentPage(param);
    for (let i = 0; i < res.data.list.length; i++) {
      res.data.list[i].title = this.filterKeyLight(res.data.list[i].title);
      res.data.list[i].digest = this.filterKeyLight(res.data.list[i].digest);
    }
    this.searchFlag = true;
    this.queryList = res.data.list;
    this.resList = res.data;
  }
  searchFlag = false;
  handelQuery() {
    this.getQueryContentPage();
    this.searchRouter();
  }
  searchRouter() {
    this.$router.push(`/study/news/?class=${this.classCode}&search=${this.searchText}`);
  }
  handelClass(item) {
    this.$router.push(`/study/news/?class=${item.classCode}&search=${this.searchText}`);
    this.active = item.classCode;
    this.classCode = item.classCode;
    this.className = item.className;
    this.getQueryContentPage();
  }
  async handelGetHtml(item) {
    let contentCode = item.contentCode;
    this.contentCode = item.contentCode;
    let classCode = this.classCode;
    let routeData = this.$router.resolve({
      path: `/study/news/?class=${classCode}&content=${contentCode}&search=${this.searchText}`
    });
    window.open(routeData.href, "_blank");
  }
  async getDetail() {
    const res = await this.queryContentDetail({ contentCode: this.contentCode });
    this.contentDetail = res.data;
  }
  async praise() {
    this.$message.success(t("v210831.thank-you-for-feedback"));
    await this.likeContent({ contentCode: this.contentDetail.contentCode, like: !this.contentDetail.like });
    this.contentDetail.like = !this.contentDetail.like;
    this.contentDetail.likeNum =
      this.contentDetail.like === true ? this.contentDetail.likeNum + 1 : this.contentDetail.likeNum - 1;
  }
  hidden() {
    this.newsFlag = true;
    this.handelClass({ classCode: this.classCode });
  }
  // ////
}
